import { CheckIcon } from 'components/svg';
import { connectURL } from 'constants/defaultValues';
import React from 'react';

const workFor = [
  'Employee & Executive Compensation',
  'Sales Compensation Programs',
  'Equity Compensation Plans',
  'Innovative Benefit & Compensation Projects',
  'Team Member Rewards & Incentives',
];

function Solutions() {
  return (
    <div className="section background">
      <div className="container" id="solutions">
        <div className="row">
          <div className="col-12 offset-0 col-lg-8 offset-lg-2 text-center mb-4">
            <h2>How Wellpay Can Work For You:</h2>
          </div>
        </div>
        <div className="list-table">
          <div className="list-body">
            {workFor.map((item, index) => (
              <div className="list-col" key={index}>
                <CheckIcon />
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="d-flex py-5 justify-content-center">
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a className="btn btn-light btn-xl" href={connectURL} target="_blank">
            Talk to us <i className="simple-icon-arrow-right" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Solutions;
